<template>
    <div class="faq"
        :class="{ active: toggledFaq === faq.id }"
        @click="$emit('toggleFaq', faq.id)"
    >
        {{ faq.question }}
        <img :src="`${publicPath}/img/angle.svg`" alt="angle" class="angle" :class="{ mirror: toggledFaq === faq.id }">
        <div class="answer" :class="{ visible: toggledFaq === faq.id }" v-html="faq.answer.join(' ')" />
    </div>
</template>

<script>
export default {
    name: 'Faq',
    props: {
        faq: Object,
        toggledFaq: Number
    },
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    },
}
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/main.scss';

    .faq {
        position: relative;
        padding: 0.5rem 2rem 0.5rem 1rem;
        color: white;
        font-size: 1rem;
        line-height: 1.5;
        font-weight: 700;
        border-bottom: 2px solid white;
        cursor: pointer;

        @include bp-lg {
            padding: 1rem 2rem;
            font-size: 1.5rem;
        }

        &:last-child {
            border-bottom: none;
        }

        &:hover, &.active {
            background: rgba(white, 0.2);
        }

        .angle {
            position: absolute;
            top: 1rem;
            right: 0.75rem;
            width: 0.5rem;
            height: 0.5rem;
            transition: all 0.25s;

            &.mirror {
                transform: rotate(180deg);
            }

            @include bp-lg {
                top: 1.625rem;
                right: 1.25rem;
                width: 1rem;
                height: 1rem;
            }
        }

        .answer {
            max-height: 0;
            font-size: 1rem;
            font-weight: 400;
            overflow: hidden;
            @include transition-in();

            &.visible {
                margin-top: 2rem;
                max-height: 60rem;
                @include transition-in();
            }

            ::v-deep {
                .table {
                    position: relative;
                    margin: 0 0 16px;
                    
                    td {
                        color: rgba(white, 0.75);
                        padding: 2px 4px;
                        text-align: left;

                        &.total {
                            border-top: 1px dotted white
                        }

                        &.amount {
                            text-align: right;
                        }
                    }
                }

                .img {
                    width: 100%;

                    @include bp-sm {
                        width: 240px;
                    }
                }

                p {
                    color: rgba(white, 0.75);
                }

                 hr {
                    border: none;
                    border-top: 1px dotted white;
                    margin: 16px 0;
                }

                a:link, a:visited {
                    color: white;
                    text-decoration: none;
                    font-weight: 700;

                    &:hover {
                        text-decoration: underline;
                        transition: all 0.3s;
                    }
                }
            }
        }
    }
</style>